import { render, staticRenderFns } from "./PayRollPage.vue?vue&type=template&id=644747af&scoped=true&"
import script from "./PayRollPage.vue?vue&type=script&lang=js&"
export * from "./PayRollPage.vue?vue&type=script&lang=js&"
import style0 from "./PayRollPage.vue?vue&type=style&index=0&id=644747af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644747af",
  null
  
)

export default component.exports